module.exports = __webpack_public_path__ + "images/sam/picker_mask.png";